<div class="m-transport-chips">
  @for (group of groups(); track group) {
  <span class="m-transport-chips__chip">{{ group }}</span>
  } @if (groups().length === 0) {
  <span class="m-transport-chips__empty">Aucun groupe</span>
  }
</div>
